export const
    DRAWER_OPENED = 'drawer_opened',
    DRAWER_CLOSED = 'drawer_closed',
    SEARCH = 'search',
    MAP_STYLE_CHANGED = 'map_style_changed',
    OX_MODE_CHANGED = 'ox_mode_changed',
    OX_LIST_STYLE_CHANGED = 'ox_list_style_change',
    LANG_CHANGED = 'current_lang_change';



// WEBPACK FOOTER //
// src/store/ui/types.js